import { StyleSheet } from '@rexlabs/styling';

export const SIZE_BANDS = ['<300', '300-350', '351-512', '>512'] as const;
const GRID_COLS = `200px repeat(${SIZE_BANDS.length}, 1fr)`;
const LOT_GRID_COLS = '1.5fr 0.8fr 0.8fr 0.8fr 0.8fr 1fr 1fr 1fr 0.8fr';

export const defaultStyles = StyleSheet({
  header: {
    display: 'grid',
    gridTemplateColumns: GRID_COLS,
    borderBottom: '2px solid #d1d5db',
    backgroundColor: '#f9fafb',
    fontWeight: 700,
    fontSize: '12px'
  },
  row: {
    display: 'grid',
    gridTemplateColumns: GRID_COLS,
    borderBottom: '1px solid #e5e7eb',
    '&:hover': {
      backgroundColor: '#f9fafb'
    }
  },
  lotHeader: {
    display: 'grid',
    gridTemplateColumns: LOT_GRID_COLS,
    borderBottom: '2px solid #d1d5db',
    backgroundColor: '#f9fafb',
    fontWeight: 700,
    fontSize: '12px'
  },
  lotRow: {
    display: 'grid',
    gridTemplateColumns: LOT_GRID_COLS,
    borderBottom: '1px solid #e5e7eb',
    '&:hover': {
      backgroundColor: '#f9fafb'
    }
  },
  cell: {
    padding: '10px 12px',
    textAlign: 'center',
    fontSize: '13px'
  },
  cellLeft: {
    padding: '10px 12px',
    fontWeight: 600,
    fontSize: '13px'
  },
  cellRight: {
    padding: '10px 12px',
    textAlign: 'right',
    fontSize: '13px'
  },
  avgDays: {
    fontWeight: 700,
    fontSize: '14px'
  },
  soldCount: {
    fontSize: '11px',
    color: '#6b7280'
  },
  emptyRow: {
    padding: '40px',
    textAlign: 'center',
    color: '#6b7280',
    gridColumn: '1 / -1'
  },
  filterLabel: {
    fontSize: '13px',
    fontWeight: 600,
    marginRight: '6px'
  },
  tabButton: {
    padding: '8px 16px',
    border: '1px solid #d1d5db',
    backgroundColor: '#fff',
    cursor: 'pointer',
    fontSize: '13px',
    fontWeight: 500
  },
  tabButtonActive: {
    padding: '8px 16px',
    border: '1px solid #3b82f6',
    backgroundColor: '#3b82f6',
    color: '#fff',
    cursor: 'pointer',
    fontSize: '13px',
    fontWeight: 600
  }
});
